import CardDropdown from 'components/common/CardDropdown';
import FalconCardHeader from 'components/common/FalconCardHeader';
import React from 'react';
import { Card, Col, Row, Table } from 'react-bootstrap';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import { getColor } from 'helpers/utils';
import { tooltipFormatter } from 'helpers/echart-utils';
import * as echarts from 'echarts/core';
import classNames from 'classnames';
import ProfileInsights from './donor-profile-components/ProfileInsights';
import ProfileDonorInfo from './donor-profile-components/ProfileDonorInfo';
import RelatedContacts from './donor-profile-components/RelatedContacts';

const DonorProfile = () => {
  const yarns = [2020, 2021, 2022];

  const data = [1330, 900, 1800];

  const getOption = () => ({
    tooltip: {
      trigger: 'axis',
      padding: [7, 10],
      backgroundColor: getColor('gray-100'),
      borderColor: getColor('gray-300'),
      textStyle: { color: getColor('dark') },
      borderWidth: 1,
      formatter: tooltipFormatter,
      transitionDuration: 0,
      axisPointer: {
        type: 'none'
      }
    },
    xAxis: {
      type: 'category',
      data: yarns,
      axisLine: {
        lineStyle: {
          color: getColor('gray-300'),
          type: 'solid'
        }
      },
      axisTick: { show: false },
      axisLabel: {
        color: getColor('gray-800'),
        formatter: value => value.substring(0, 4),
        margin: 15
      },
      splitLine: {
        show: false
      }
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        show: true,
        color: getColor('gray-800'),
        margin: 15
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: getColor('gray-300'),
          type: 'dashed'
        }
      },
      axisTick: { show: false },
      axisLine: { show: false },
      min: 0,
      minInterval: 500
    },
    series: [
      {
        type: 'bar',
        name: 'Total',
        data,
        lineStyle: { color: getColor('primary') },
        itemStyle: {
          color: getColor('primary'),
          borderRadius: [3, 3, 0, 0]
        },
        barWidth: 13,
        showSymbol: false,
        symbol: 'circle',
        smooth: false,
        emphasis: {
          scale: true
        }
      }
    ],
    grid: { right: '3%', left: '20%', bottom: '12%', top: '5%' }
  });

  const profileDetails = [
    { id: 1, title: 'LifeTime Contribution', value: '$18,461' },
    { id: 2, title: 'YTD Contribution', value: '$8,850' },
    { id: 3, title: 'Outstanding Pledges', value: '$0,0' },
    { id: 4, title: 'First Donation', value: '$850.0' },
    { id: 5, title: 'Most recent Donation', value: '$1500.0' },
    {
      id: 6,
      title: 'Created',
      value: '06/03/2018',
      valueClassName: 'text-400'
    },
    { id: 7, title: 'Assignee', value: 'Staff_Name' }
  ];

  return (
    <>
      <Card className="mb-3">
        <FalconCardHeader
          title={<h4 className="fw-bold">Profile Overview</h4>}
          light={false}
          titleTag="div"
          className="pb-1"
          menuClassName="align-items-start"
          endEl={<CardDropdown btnRevealClass="btn-falcon-default" />}
        />
        <Card.Body>
          <Row>
            <Col md={6}>
              <Table size="sm" borderless className="font-sans-serif ">
                <tbody>
                  {profileDetails?.map(detail => (
                    <tr key={detail.id}>
                      <td className="text-start ps-0">{detail.title}</td>
                      <td
                        className={classNames(
                          'text-start',
                          detail.valueClassName
                        )}
                      >
                        {detail.value}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Col>
            <Col md={1} />
            <Col md={5}>
              <div>
                <ReactEChartsCore
                  echarts={echarts}
                  option={getOption()}
                  style={{ height: '14.75rem' }}
                />
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <ProfileDonorInfo />
      <ProfileInsights />
      <RelatedContacts />
    </>
  );
};

export default DonorProfile;
